import { render, staticRenderFns } from "./skyCheckBoxCardPrd.vue?vue&type=template&id=6797dc32&scoped=true"
import script from "./skyCheckBoxCardPrd.vue?vue&type=script&lang=js"
export * from "./skyCheckBoxCardPrd.vue?vue&type=script&lang=js"
import style0 from "./skyCheckBoxCardPrd.vue?vue&type=style&index=0&id=6797dc32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797dc32",
  null
  
)

export default component.exports